export default "__VITE_ASSET__OvVAjaHC__"